/*global NodeListOf*/
/*eslint no-undef: "error"*/

import type {Decisions, SearchParams} from '@/typings/helpCenter';
import React from 'react';

/**
 * generate static elements
 *
 * @param {NodeListOf<Element>} ele element from html string
 * @returns {Element[]}
 */
export function generateElements(ele: NodeListOf<Element>) {
  return Array.from(ele).map((item, index) => (
    <div key={index}>{extractTextAndAnchorTags(item)}</div>
  ));
}

/**
 * Extract text content and anchor tag from an element
 *
 * @param {Element} ele element from html string
 * @returns {Element[]}
 */
export function extractTextAndAnchorTags(ele: Element) {
  const nodeList = ele.childNodes;
  return Array.from(nodeList).map((el, index) => {
    const {nodeName} = el;
    if (nodeName === '#text') {
      return <span key={index}>{el.textContent}</span>;
    } else {
      const {href, target, rel} = el as HTMLAnchorElement;
      return (
        <a
          key={index}
          href={href}
          target={target}
          rel={rel}
        >
          {el.textContent}
        </a>
      );
    }
  });
}

export function generateButtonList(decisions: Decisions) {
  const res = [];
  for (const key in decisions) {
    const stepId = key.split(':1:')[1];
    const item = {
      value: stepId,
      display: decisions[key],
    };
    res.push(item);
  }
  return res;
}

export function formatTitleForURL(title: string) {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/<[^>]*>/g, '')
    .replaceAll('strong', '');
}

/**
 * Get string value of a key in given searchParams object. If value is of type Array, then value of first element will be returned.
 * searchParam value will be an Array if URL contains duplicate query keys.
 *
 * @param {SearchParams} searchParams An object containing URL's search params
 * @param {searchParamsKey} searchParamsKey Single Key of the provided search params object
 * @returns {string}
 */
export function getSearchParamValue(
  searchParams: SearchParams,
  searchParamsKey: string,
): string {
  if (!searchParams || !searchParamsKey) return '';

  if (typeof searchParams[searchParamsKey] === 'string')
    return searchParams[searchParamsKey];

  if (
    Array.isArray(searchParams[searchParamsKey]) &&
    searchParams[searchParamsKey].length
  ) {
    return searchParams[searchParamsKey][0];
  }

  return '';
}
